<template>
  <question-base-wrapper
    :should-question-render="isCoverTypeHadContents"
    title="How much would it cost to replace the entire contents in your home?"
    v-bind="baseWrapperProps"
  >
    <validation-provider
      v-slot="{ errors, failed }"
      name="Contents Sums Ins"
      :vid="`${stepId}_contents-sums-ins`"
      :rules="{ contentsReplaceCost:
        { totalContentsCost }
      }"
      slim
    >
      <currency-input
        v-model.number="questionData.contentsSumsIns"
        hide-details="auto"
        :maxlength="inputCharsLimiters.CONTENTS_SUMS_INS_MAX"
        placeholder="e.g. 25000"
        :data-test="`${stepId}_contents_sums_ins`"
        outlined
        :error="failed"
        :error-messages="errors"
        prefix="£"
      />
    </validation-provider>
    <template
      v-if="hasContentsCalculator"
      #footer
    >
      <div
        class="text-center font-weight-medium py-6 contents-calc-wrap"
      >
        Not sure how much? You can use our
        <qz-btn
          text
          color="primary"
          data-test="toggle-calculator"
          @click="toggleContentsCalculator"
        >
          <v-icon left>
            mdi-calculator
          </v-icon>
          <span class="text-decoration-underline">Contents Calculator</span>
          <v-icon
            right
          >
            {{ contentsCalcIcon }}
          </v-icon>
        </qz-btn>
        to help.
      </div>
    </template>
  </question-base-wrapper>
</template>

<script>
import QuestionBase from '@/components/questions/Base';

import {
  CONTENT,
} from '@/payloadTemplates/home';

export default {
  name: 'question-contents-sums-in',
  extends: QuestionBase,
  props: {
    hasContentsCalculator: {
      type: Boolean,
      default: null,
    },
    isContentsCalculatorShown: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      fields: ['contentsSumsIns'],
    };
  },
  created () {
    if (!this.isCoverTypeHadContents) {
      this.questionData.contentsSumsIns = CONTENT.contentsSumsIns;
    }
  },
  computed: {
    isCoverTypeHadContents () {
      const type = this.formData.home.propertyCoverType;
      return type === 'BC' || type === 'C';
    },
    totalContentsCost () {
      return this.helpers.calcContentsSum(this.stepData);
    },
    contentsCalcIcon () {
      return this.isContentsCalculatorShown ? 'mdi-chevron-up' : 'mdi-chevron-down';
    },
  },
  methods: {
    toggleContentsCalculator () {
      this.$emit('toggle-calculator', !this.isContentsCalculatorShown);
    },
  },
};
</script>

<style lang='scss'>
.contents-label {
  .form-col {
    width: 100% !important;
  }

  & ~ .contents-helptext {
    margin-top: 0 !important;
  }
}

.contents-helptext .form-row__help-text {
  margin-top: 0;
}

.contents-calc-wrap {
  width: 100%;
  font-size: 18px;
}
</style>
